<div class="row">
  <div class="col-12">
    <p class="mbottom-12" *yatVar="deleteDate$ | async as deleteDate">
      <transloco
        *yatVar="upcomingPayment$ | async as upcomingPayment"
        id="9668eb8e-9eb0-481f-b463-1df8ebd01196"
        [key]="
          upcomingPayment
            ? 'accountUi.deactivatedAccountUi.disabledAccountWithUpcommingPayment'
            : 'accountUi.deactivatedAccountUi.disabledAccountWithoutUpcommingPayment'
        "
        [params]="{ deleteDate: deleteDate ? (deleteDate | translocoDate: { dateStyle: 'medium' }) : '', cssClass: 'block mb-2' }"></transloco>
    </p>
  </div>
</div>
<div class="in-app-two-rows mtop-12">
  <button
    yat-button
    type="submit"
    class="btn primary w-full"
    (click)="reactivate()"
    [matomoClickCategory]="MATOMO_EVENT_CATEGORY_ACCOUNT"
    matomoClickAction="ReactivateAccount"
    matomoClickName="ReactivateAccount">
    {{ 'accountUi.deactivatedAccountUi.reactivateAccount' | transloco }}
  </button>
</div>
<div class="row mtop-12">
  <div class="col-12">
    <p class="color-light c-gray font-small text-center mb-0 mbottom-16" yat-link>
      <transloco
        id="1390f1d3-f288-4b84-a18d-222eb3e1d855"
        *yatVar="accountIdLinked$ | async as accountIdLinked"
        [key]="
          showSignOutButtons
            ? accountIdLinked
              ? 'accountUi.deactivatedAccountUi.cancelOrSignOut'
              : 'accountUi.deactivatedAccountUi.cancelSignOutOrCreateAccount'
            : accountIdLinked
            ? 'accountUi.deactivatedAccountUi.cancel'
            : 'accountUi.deactivatedAccountUi.cancelOrCreateAccount'
        "
        [params]="{ cancelLink, signOutLink, createAccountLink }"></transloco>
    </p>
  </div>
</div>
